import {DetailsTabContentWrapper} from '@/features/projects/components/details-tab-content-wrapper/DetailsTabContentWrapper'
import styled, {css} from 'styled-components'

export const StyledDisabilityProfile = styled(DetailsTabContentWrapper)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: max-content max-content;
        gap: ${spacing * 4}px;
    `
)
